<template>
  <div>
    <div class="layout-padding">
      <div class="row q-mb-lg bg-white round-borders">
        <active-time-entry/>
      </div>

      <div class="row gutter-sm" v-if="timeTrackingStatisticsLoaded">
        <div class="col-md-6 col-12">
          <project-hours :data="projectHours"/>
        </div>

        <div class="col-md-6 col-12">
          <billable-hours
            :amount="billableHours"
            :style="{ height: 'calc(50% - 0.5rem)', marginBottom: '1rem' }"
          />

          <open-hours
            :amount="unbilledHours"
            :style="{ height: 'calc(50% - 0.5rem)' }"
          />
        </div>
      </div>

      <div class="q-mt-lg">
        <div class="row justify-between items-end q-mb-md">
          <span class="q-title text-bold text-blue-grey-4">{{ $t('recent_time_entries') }}</span>

          <router-link
            :to="{ name: 'time-entries' }"
            class="router-link q-subheading text-blue-grey-4"
          >
            {{ $t('view_all') }}
          </router-link>
        </div>

        <template v-if="timeEntries.length">
          <time-entries-list :time-entries="timeEntries" :showUser="false"/>
        </template>

        <template v-else>
          <div class="row justify-center items-center col-grow q-mt-xl">
            <div class="text-center">
              <img src="~assets/emptystates/time_entries_empty.svg"/>

              <h6 class="q-my-md text-faded">{{ $t('no_time_entries') }}</h6>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  import ActiveTimeEntry from 'components/TimeTracking/ActiveTimeEntry.vue'
  import BillableHours from 'components/TimeTracking/Statistics/BillableHours.vue'
  import OpenHours from 'components/TimeTracking/Statistics/OpenHours.vue'
  import ProjectHours from 'components/TimeTracking/Statistics/ProjectHours.vue'
  import TimeEntriesList from 'components/TimeTracking/TimeEntriesList'
  import { mapGetters } from 'vuex'
  import store from 'src/store'

  export default {
    computed: {
      ...mapGetters([
        'timeTrackingStatisticsLoaded',
        'projectSeconds',
        'billableSeconds',
        'unbilledSeconds',
        'timeEntries'
      ]),

      projectHours () {
        const projects = this.projectSeconds.value.slice().sort((projectA, projectB) => projectB.value - projectA.value)

        if (projects.length <= 4) {
          return projects
        }

        const largest = projects.slice(0, 3)
        const remaining = projects.slice(3).reduce((sum, project) => {
          return sum + project.value
        }, 0)

        return largest.concat([{
          project_name: this.$t('other'),
          value: remaining
        }])
      },

      billableHours () {
        return this.billableSeconds.value.length ? Math.round(this.billableSeconds.value[0].value / (60 * 60)) : 0
      },

      unbilledHours () {
        return Math.round(this.unbilledSeconds.value / (60 * 60))
      }
    },

    beforeRouteEnter (to, from, next) {
      const statistics = store.dispatch('fetchTimeTrackingStatisticsOverview')
      const activeEntry = store.dispatch('fetchActiveTimeEntry')
      const timeEntries = store.dispatch('listTimeEntries', {
        pagination: {
          rowsPerPage: 5,
          filterBy: [
            ['user_id', '=', store.getters.user.id],
            ['running', '=', false]
          ]
        }
      })

      Promise.all([statistics, activeEntry, timeEntries]).then(next)
    },

    components: {
      ActiveTimeEntry,
      BillableHours,
      OpenHours,
      ProjectHours,
      TimeEntriesList
    }
  }
</script>

<style src="components/Dashboard/dash-number-box.styl" lang="stylus"></style>
